import { ReactComponent as CheckBoxActiveIcon } from '../../assets/icons/check-box-active-icon.svg';
import { ReactComponent as CheckBoxIcon } from '../../assets/icons/check-box-icon.svg';

interface CustomCheckInputProperties {
  inputLabel?: string;
  value: (string | number)[];
  name: string;
  list: { label: string; value: string | number }[];
  onChangeValue: (name: string, value: (string | number)[]) => void;
  valueRequired?: boolean;
  error?: boolean;
  errorMessage?: string;
  showOnlySelected?: boolean;
}

// To-do -> This should be re-designed as single checkbox component, instead of mapping over list of items
/**
 * Check box buttons function component
 * @param {any} param0 - The param0
 * @param {any} param0.inputLabel - The inputLabel prop
 * @param {any} param0.name - The name prop
 * @param {any} param0.value - The value prop
 * @param {any} param0.list - The list prop
 * @param {any} param0.onChangeValue - The onChangeValue prop
 * @param {any} param0.valueRequired - The valueRequired prop
 * @param {any} param0.error - The error prop
 * @param {any} param0.errorMessage - The errorMessage prop
 * @param {any} param0.showOnlySelected - The showOnlySelected prop
 */
function CheckBoxButtons({
  inputLabel,
  name,
  value,
  list,
  onChangeValue,
  valueRequired,
  error,
  errorMessage,
  showOnlySelected,
}: CustomCheckInputProperties) {
  /**
   * check box button handle function
   * @param {any} changeValue - The changeValue
   */
  const handleValueChange = (changeValue: string | number) => {
    const newValue = value.includes(changeValue)
      ? value.filter((v) => v !== changeValue)
      : [...value, changeValue];
    onChangeValue(name, newValue);
  };

  const filteredList = showOnlySelected ? list.filter((item) => value.includes(item.value)) : list;

  return (
    <div className="check-box-button-wrap">
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className="custom-check-box">
        <div className="check-box-list">
          {filteredList.map((checkbox) => (
            <div
              key={checkbox.value}
              className="check-box-item"
              onClick={() => handleValueChange(checkbox.value)}
              role="presentation">
              <div className="check-box-icon">
                {value.includes(checkbox.value) ? <CheckBoxActiveIcon /> : <CheckBoxIcon />}
              </div>
              <div className="check-box-label">{checkbox.label}</div>
            </div>
          ))}
        </div>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CheckBoxButtons.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  error: false,
  errorMessage: '',
  showOnlySelected: false,
};

export default CheckBoxButtons;
